import axios from '../apis/Axios';
import useAuth from './useAuth';

const useRefreshToken = () => {
    const { setAuth } = useAuth();

    const refresh = async () => {
        const res = await axios.get('api/User/refresh', { 
            withCredentials: true
        });
        setAuth(prev => {
            return { 
                ...prev,
                authToken: res.data.authToken,
                username: res.data.username,
                userID: res.data.userID,
                role: res.data.role,
             }
        });
        return res.data.authToken;
    }
    return refresh;
}

export default useRefreshToken;
